import React from "react";
import Navbar from "../components/Navbar/Navbar";
import Footer from "../components/Footer/Footer";

const UnderConstruction = () => {
    return (
        <div className="d-flex flex-column min-vh-100">
            <Navbar className="fixed-top"/>
            <div className="flex-fill d-flex align-items-center justify-content-center text-center pt-5 mt-5 mb-5">
                <div className="text-center">
                    <h1 className="text-4xl font-bold mb-4">🚧 Page Under Construction</h1>
                    <p className="text-lg text-gray-600">We're working on this page. Check back soon!</p>
                </div>
            </div>
            <Footer className="navbar bg-white shadow-sm fixed-bottom" />
        </div>
    );
};

export default UnderConstruction;
